import { create } from 'zustand';

import { EMPTY_NODES } from '../consts';
import { type ChatComposerNodeSlice, createChatComposerNodeSlice } from './slices/createChatComposerNodeSlice';

export type ChatComposerNodeState = ChatComposerNodeSlice;

export const useChatComposerNodeStore = create<ChatComposerNodeState>()((...args) => ({
  ...createChatComposerNodeSlice()(...args),
}));

/** Returns the composer nodes record, with a stable empty reference when empty. */
export const useChatComposerNodes = () => {
  return useChatComposerNodeStore((state) => (Object.keys(state.nodes).length > 0 ? state.nodes : EMPTY_NODES));
};
